import {useCallback, useMemo} from 'react'
import {Box, Button} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../common/store'
import {addText3D, selectActiveScene} from '../../../common/components/store/scenesSlice'
import {useAppTokens} from '../../theme'
import type {ThemeTokens} from '../../theme'
import Text3DItem from './Text3DItem'

// ── Text3DPanel — add button + list of 3D text items ──────────────

const Text3DPanel = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const tokens = useAppTokens()
  const texts3d = useAppSelector((s) => selectActiveScene(s).texts3d)
  const sx = useMemo(() => buildStyles(tokens), [tokens])

  const handleAdd = useCallback(() => {
    dispatch(addText3D())
  }, [dispatch])

  return (
    <Box>
      <Button variant="outlined" size="small" fullWidth startIcon={<AddIcon />} onClick={handleAdd} sx={sx.addButton}>
        {t('text3d.addText')}
      </Button>
      <Box sx={sx.list}>
        {texts3d.map((text) => (
          <Text3DItem key={text.id} text3d={text} />
        ))}
      </Box>
    </Box>
  )
}

const buildStyles = (tokens: ThemeTokens) => ({
  addButton: {
    fontSize: 12,
    textTransform: 'none' as const,
    color: tokens.text.primary,
    borderColor: tokens.accordion.border,
    marginBottom: '8px',
    '&:hover': {
      borderColor: tokens.text.secondary,
    },
  },
  list: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
})

export default Text3DPanel
